import { Component, Input, OnChanges, SimpleChanges, OnInit, OnDestroy } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { TranslateService } from "@ngx-translate/core";
import { takeUntil } from "rxjs/operators";

export interface BreadcrumbItem {
  label: string;
  routerLink?: string[];
  clickHandler?: () => void;
}

@Component({
  selector: "fui-layout-header",
  templateUrl: "layout-header.component.html",
  standalone: false,
})
export class FuiLayoutHeaderComponent extends BaseComponent implements OnChanges, OnInit, OnDestroy {
  @Input() breadcrumbs: BreadcrumbItem[] = [];
  @Input() headingText: string;
  @Input() description: string;
  @Input() showDescription: boolean = true;

  public translatedHeadingText: string;
  public translatedDescription: string;
  public translatedBreadcrumbs: BreadcrumbItem[] = [];

  constructor(
    userService: UserService,
    private translate: TranslateService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.updateTranslations();
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateTranslations();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.headingText || changes.description || changes.breadcrumbs) {
      this.updateTranslations();
    }
  }

  private translateString(keyOrText: string): string {
    if (!keyOrText) {
      return keyOrText;
    }

    const translated = this.translate.instant(keyOrText);
    return translated !== keyOrText ? translated : keyOrText;
  }

  private updateTranslations() {
    this.translatedHeadingText = this.translateString(this.headingText);
    this.translatedDescription = this.translateString(this.description);
    this.translatedBreadcrumbs = this.breadcrumbs.map((crumb) => ({
      ...crumb,
      label: this.translateString(crumb.label),
    }));
  }
}
